import { ScheduleLotCard } from "./ScheduleLotCard";

export enum ScheduleSectionKey {
  Today = "today",
  ThisWeek = "thisWeek",
  NextWeek = "nextWeek"
}

export interface ScheduleSection {
  key: ScheduleSectionKey;
  label: string;
  /** "Sep 14", "Sep 15 - 20", "Sep 29 - Oct 5", or "September 4th" for a one day span. */
  dateLabel: string;
  /** A single day needs no per-card date; a span does. */
  showCardDates: boolean;
  cards: ScheduleLotCard[];
}
